<mat-progress-bar [class.visible]="loader.progress$ | async"
                  [value]="loader.progress$ | async"
                  class="progress-bar"
                  mode="determinate"></mat-progress-bar>
